// 项目查看接口
import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 项目数据分页查询-招标采购
export function getBidProjectListApi(params) {
  return request({
    url: baseUrl + '/monitor/project/bidding-orders',
    method: 'get',
    params
  })
}

// 项目数据分页查询-询比
export function getInquiryProjectListApi(params) {
  return request({
    url: baseUrl + '/monitor/project/inquiry-orders',
    method: 'get',
    params
  })
}

// 项目数据分页查询-竞价
export function getCompeteProjectListApi(params) {
  return request({
    url: baseUrl + '/monitor/project/competition-orders',
    method: 'get',
    params
  })
}

// 项目数据分页查询-备案采购
export function getSupplementProjectListApi(params) {
  return request({
    url: baseUrl + '/monitor/project/bidding-registrations',
    method: 'get',
    params
  })
}

// 项目数据分页查询-谈判采购
export function getNegotiationV2ListApi(params) {
  return request({
    url: baseUrl + `/monitor/project/negotiate-orders`,
    method: 'get',
    params
  })
}

// 项目数据分页查询 - 直接采购
export function getDirectListApi(params) {
  return request({
    url: `${baseUrl}/monitor/project/bidding-direct`,
    method: 'get',
    params
  })
}

// 采购身份数据项统计
export function getStatisticApi(params) {
  return request({
    url: baseUrl + '/monitor/statistics/purchaser',
    method: 'get',
    params
  })
}

// 代理身份数据统计项
export function getStatisticInAgencyApi(params) {
  return request({
    url: baseUrl + '/monitor/statistics/agent',
    method: 'get',
    params
  })
}

// 招标代理添加代理服务费
export function getAgentTotalFeeApi(params) {
  return request({
    url: baseUrl + `/monitor/project/agent-total`,
    method: 'get',
    params
  })
}

// 招标采购-导出
export function exportBiddingOrdersApi(data) {
  window.open(
    addQueryToUrl(`${baseUrl}/monitor/project/export/bidding-orders`, data)
  )
}

// 询比采购-导出
export function exportInquiryOrdersApi(data) {
  window.open(
    addQueryToUrl(`${baseUrl}/monitor/project/export/inquiry-orders`, data)
  )
}

// 竞价采购-导出
export function exportCompetitionOrdersApi(data) {
  window.open(
    addQueryToUrl(`${baseUrl}/monitor/project/export/competition-orders`, data)
  )
}

// 备案采购-导出
export function exportBiddingRegistrations(data) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/export/bidding-registrations`,
      data
    )
  )
}

// 谈判采购-导出
export function exportNegotiationV2ListApi(data) {
  window.open(
    addQueryToUrl(`${baseUrl}/monitor/project/export/negotiate-orders`, data)
  )
}

// 直接采购-导出
export function exportDirectListApi(data) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/export/purchase-direct-orders`,
      data
    )
  )
}

// 查询统计缓存表头设置
export function saveHeaderSettingApi(purchaseType, data) {
  return request({
    url: baseUrl + `/workbench/monitor-console/setting`,
    method: 'post',
    params: { purchaseType },
    data
  })
}

// 获取表头设置信息
export function getHeaderSettingApi(purchaseType) {
  return request({
    url: baseUrl + `/workbench/monitor-console/setting`,
    method: 'get',
    params: { purchaseType }
  })
}

// 项目统计明细报表(包括其它公司)
export function getProjectStatisticUrlApi(params) {
  return request({
    url: baseUrl + '/bi/monitor/project-analysis/others-company',
    method: 'get',
    params
  })
}
